import axios from 'axios';

const API_HOST = (
  process.env.VUE_APP_API_URL || 'https://admin.jugendkirche-mhl.de'
).replace(/\/$/, '');

const instance = axios.create({
  baseURL: `${API_HOST}/api`
});

export default instance;
